export var SortDirection;
(function (SortDirection) {
  SortDirection["NONE"] = "";
  SortDirection["ASCENDING"] = "asc";
  SortDirection["DESCENDING"] = "desc";
})(SortDirection || (SortDirection = {}));
